<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :schema="schema"
            :idn-character-sets="idnCharacterSets"
            @form-submitted="submitForm"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Settings/DomainConfiguration/Form'
import { route } from '~@/Composables/route'

defineProps({
    errors: {
        type: Object,
        default: () => { return {} }
    },
    schema: {
        type: Object,
        default: () => { return {} }
    },
    idnCharacterSets: {
        type: Array,
        default: () => { return [] }
    }
})

const submitForm = (form) => {
    form.post(route('settings.domain-configuration.store'))
}
</script>
